import React from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'

import { Button, Checkbox, Form, notification } from 'antd'

import _ from 'lodash'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request from '../../../../request'
import { connect } from 'react-redux'
import styles from '../../faculty/add/styles.less'

let facultyId = null

@Form.create()
class AddFaculty extends React.Component {
    state = {
        loading: false,
        arr: [],
        streamsArray: [],
        inputTypes: [
            {
                fields: [
                    {
                        label: 'Faculty Name',
                        key: 'facultyName',
                        required: true
                    }
                ]
            }
        ]
    }

    constructor(props) {
        super(props)
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                console.log(values, '**************************')

                if (facultyId) {
                    values = { ...values, _id: facultyId }

                    dispatch(showLoader())

                    let x = await Request.updateFaculty(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                } else {
                    dispatch(showLoader())

                    let x = await Request.addFaculty(values)
                    dispatch(hideLoader())
                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }
    setFormValues = async facultyId => {
        try {
            let { doc } = await Request.getFaculty(facultyId)

            if (doc) {
                let tempObj = {}

                let inputTypes = this.state.inputTypes


                _.each(inputTypes, (val, kk) => {
                    if (kk == '0') {
                        _.each(inputTypes[0].fields, (v, k) => {
                            tempObj[v.key] = doc[v.key]
                        })
                    }
                })

                tempObj.streams = doc.streams

                this.props.form.setFieldsValue(tempObj)
            }
        } catch (e) {
            console.log(e)
        }
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        facultyId = searchParams.get('id')



        if (facultyId) {
            this.setState({ showFiles: 1 })
            this.setFormValues(facultyId)
        }
    }

    render() {
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props

        const optionsWithDisabled = [
            { label: 'SCIENCE-MEDICAL', value: 'Medical' },
            { label: 'SCIENCE-NON MEDICAL', value: 'NonMedical' },
            { label: 'COMMERCE', value: 'Commerce' },
            { label: 'ARTS', value: 'Arts' }

        ]
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 }
            }
        }
        return (
            <PageHeaderWrapper title={`${facultyId ? 'Edit' : 'Add New'} Faculty`}>
                <div style={{ background: 'white' }}>
                    <div style={{ padding: 20 }}>
                        <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <div key={key + 1}>
                                        <GetAllFormFields
                                            inputSchema={this.state.inputTypes[key]}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </div>
                                )
                            })}

                            <Form.Item label={'Streams'} {...formItemLayout}>

                                {getFieldDecorator('streams', { rules: [{ required: true }] })(<Checkbox.Group

                                    className={styles.checkbox}
                                    checked={true}
                                    options={optionsWithDisabled}
                                    onChange={(checkedValues) => {
                                        this.setState({ streamsArray: checkedValues })
                                    }}
                                />)}

                            </Form.Item>

                            <div style={{ textAlign: 'center' }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFaculty)
